'use strict';

exports.__esModule = true;
exports._errorInit = exports._logInit = exports.error = exports.info = exports.debug = exports.log = undefined;

var _environment = require('./environment');

var _browser = require('./browser');

var _logInit = function _logInit() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var console = (0, _browser.getWindow)().console;
  if (process.env.NODE_ENV !== 'production' && console && console.log) {
    if (Function.prototype.bind) {
      return Function.prototype.bind.call(console.log, console);
    }
    return function () {
      Function.prototype.apply.call(console.log, console, args);
    };
  }
  return function () {};
};

var log = _logInit();

var debug = function debug() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if ((0, _environment.isDebug)()) {
    log.apply(null, args);
  }
};

var _errorInit = function _errorInit() {
  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  var console = (0, _browser.getWindow)().console;
  if (process.env.NODE_ENV !== 'production' && console && console.error) {
    if (Function.prototype.bind) {
      return Function.prototype.bind.call(console.error, console);
    }
    return function () {
      Function.prototype.apply.call(console.error, console, args);
    };
  }
  return function () {};
};

var error = _errorInit();

exports.log = log;
exports.debug = debug;
exports.info = log;
exports.error = error;

// Private exports for testing

exports._logInit = _logInit;
exports._errorInit = _errorInit;